import { render, staticRenderFns } from "./BeboxItem.vue?vue&type=template&id=336ea0b0&"
import script from "./BeboxItem.vue?vue&type=script&lang=js&"
export * from "./BeboxItem.vue?vue&type=script&lang=js&"
import style0 from "./BeboxItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports